// src/App.jsx
import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import ChatProvider from './components/chatai/ChatProvider';
import router from './router';

// Importar estilos globales
import './styles/global.css';

function App() {
  const assistantId = "asst_nf073rrkcNnK25TSQYvzG6VP"; // Set your assistant ID here

  return (
    <ThemeProvider>
      <div className="App">
        <RouterProvider router={router} />
        {/* Chat provider with absolute positioning */}
        <div style={{ position: 'relative', zIndex: 9999 }}>
          <ChatProvider assistantId={assistantId} />
        </div>
      </div>
    </ThemeProvider>
  );
}

export default App;